import { Cart } from "@app/types/cart"
import { EVENT_CART_UPDATE } from "@app/components/cart"

export const dispatchCartUpdate = (cart: Cart) => {
  window.cart = cart
  document.dispatchEvent(new CustomEvent(EVENT_CART_UPDATE, { detail: { cart } }))
}
